module.exports = __webpack_public_path__ + "static/media/vacasa-logo-horizontal-light.0a165821.svg";